/*
 * @Author: LZH
 * @Date: 2023-04-03 10:43:52
 * @LastEditors: Do not edit
 * @LastEditTime: 2026-07-07 17:59:09
 * @Description:
 */
import message from "./message/tn";
import placeholder from "./placeholder/tn";
let NODE_ENV = window.XINPOC_WEB_CONFIG.isProject;
let title = {
  globalpoc:"Globalpoc",
  hpyj:"เซินเจิ้น Haopan Yijia Technology Co., Ltd.",
  EuroNews:"WOUXUN Global",
  quansheng:"QUESUM",
  yuantong:"pocptt",
  chunsheng:"poclink"
};
let conpanyname = {
    yuantong:"Quanzhou YANTON Electronics Co., Ltd."
}

let beian = {
    yuantong:"Website record number"
}

let icp = {
    yuantong:"Guangdong ICP No. 16086702"
}

let copyright = {
    yuantong:"Copyright © 2021-2022 Quanzhou YANTON Electronics Co., Ltd. Version: v1.7.2"
}
export default {
  language: {
    name: "ภาษาไทย",
    title: "ภาษา",
  },
  about: {
    title: title[NODE_ENV] || "โกลบอล อินเตอร์คอม",
    conpanyname: conpanyname[NODE_ENV] || "บริษัท เซินเจิ้น บอนาร์ด อินฟอร์เมชั่น เทคโนโลยี จำกัด",
    beian: beian[NODE_ENV] || "หมายเลขลงทะเบียนเว็บไซต์",
    icp: icp[NODE_ENV] || "กวางตุ้ง ICP เลขที่ 16086702",
    copyright: copyright[NODE_ENV] || "ลิขสิทธิ์: Shenzhen Bonard Information Technology Co., Ltd. หมายเลขเวอร์ชัน: v2.1.8 ลิขสิทธิ์ © 2021-2022",
  },
  login: {
    tag: {
      agent: "ตัวแทน",
      company: "หน่วย",
    },

    placeholder: {
      account: "กรุณากรอกบัญชีเข้าสู่ระบบของคุณ",
      password: "กรุณากรอกรหัสผ่านเข้าระบบ",
    },

    button: {
      login: "เข้าสู่ระบบ",
      remember: "จำฉันได้ไหม?",
    },

    tips: {
      empty: "บัญชีหรือรหัสผ่านไม่สามารถว่างเปล่าได้",
      not_account: "บัญชีไม่ได้มีอยู่",
      err_password: "รหัสผ่านผิด",
      completethepuzzle: "ลากแถบเลื่อนด้านล่างเพื่อไขปริศนาให้สมบูรณ์",
      Verificationissuccessful: "การยืนยันสำเร็จ",
      Verificationerrorpleasetryagain:
        "เกิดข้อผิดพลาดในการตรวจสอบ กรุณาลองอีกครั้ง",
    },
  },
  from: {
    //表单
    icon: "อวาตาร์",
    Agent_name: "ชื่อตัวแทน",
    Account: "เข้าสู่ระบบบัญชี",
    Contact_name: "ชื่อผู้ติดต่อ",
    mobile: "เบอร์โทรศัพท์",
    uName: "ชื่อ",
    recharge_contact: "ข้อมูลติดต่อต่ออายุ",
    Select_Address: "เลือกที่อยู่",
    Detailed_address: "ที่อยู่โดยละเอียด",
    Not_filled_in: "ไม่ได้กรอก",
    contact_information: "ข้อมูลการติดต่อ",
    area: "พื้นที่",
    Reset_Password: "รีเซ็ตรหัสผ่าน",
  },
  placeholder: {
    ...placeholder,
  },
  message: {
    //提示
    ...message,
  },
  but: {
    //按钮
    send_out: "ส่ง",
    preserve: "บันทึก",
    confirm: "ยืนยัน",
    define: "แน่นอน",
    next: "ขั้นตอนต่อไป",
  },

  agent: {
    Agency_account: "บัญชีตัวแทน",
    Contact_information: "ข้อมูลติดต่อ",
    Please_enter_agentname: "กรุณากรอกชื่อตัวแทน",
    agentname_required: "(ต้องมี: 4-20 ตัวอักษร, ตัวอักษร, ตัวเลข)",
    Please_enter_loginAccount: "กรุณากรอกบัญชีเข้าสู่ระบบของคุณ",
    loginAccount_required: "(จำเป็นต้องมี: ตัวอักษรและตัวเลข 6-20 ตัว)",
    Please_enter_loginPassword: "กรุณากรอกรหัสผ่านเข้าระบบ",
    loginPassword_required: "(จำเป็นต้องมี: ตัวอักษรและตัวเลข 6-16 ตัว)",
    Please_enter_contactname: "กรุณากรอกชื่อผู้ติดต่อ",
    contactname_required: "(จำเป็นต้องมี: 2-20 ตัวอักษร, ตัวอักษร, ตัวเลข)",
    Please_enter_address: "กรุณากรอกที่อยู่ของตัวแทนโดยละเอียด",
    address_optional: "(ไม่จำเป็น)",
    search_agent: "ค้นหาตัวแทน",
    recover_integer: "จำนวนบัตรบริการที่ต้องการกู้คืนจะต้องเป็นจำนวนเต็ม",
    recover_num: "ปริมาณการเรียกคืนต้องมากกว่า 0",
  },

  navigation: {
    personal_center: "ศูนย์ข้อมูลส่วนบุคคล",
    search: "ค้นหา",
    my_agent: "บริษัทของฉัน",
    agent_list: "รายชื่อตัวแทน",
    create_agent: "สร้างหน่วยงาน",

    my_company: "หน่วยของฉัน",
    company_list: "รายชื่อหน่วย",
    create_company: "สร้างหน่วย",

    my_group: "กลุ่มของฉัน",
    group_list: "รายชื่อกลุ่ม",
    create_group: "สร้างกลุ่ม",

    my_user: "ผู้ใช้ของฉัน",
    user_list: "รายชื่อผู้ใช้",
    create_user: "สร้างผู้ใช้",

    news_notice: "การแจ้งเตือนข้อความ",
    Scanning_code_found: "สแกนรหัสเพื่อสร้าง",

    function_card_sell: "จำหน่ายบัตรบริการ",
    function_card_record: "บันทึกบัตรบริการ",
    system_annoucement: "ประกาศระบบ",

    my_bounding: "รั้วของฉัน",
    bounding_list: "รายการรั้ว",
    create_bounding: "สร้างรั้ว",

    recording_record: "การบันทึกเสียง",
    sos_record: "บันทึก SOS",
    broadcast_record: "บันทึกการออกอากาศ",
    Agent_details: "รายละเอียดตัวแทน",
    Scancodetocreate: "สแกนรหัสเพื่อสร้าง",
    Createuserinformation: "สร้างข้อมูลผู้ใช้",
    Confirmdetails: "ยืนยันรายละเอียด",
    EditOrganizationInformation: "แก้ไขข้อมูลหน่วย",
    notificationreminder: "การแจ้งเตือนการแจ้งเตือน",
    selectgroup: "เลือกกลุ่ม",
    edituserinformation: "แก้ไขข้อมูลผู้ใช้",
    Userreplacementcard: "การเปลี่ยนบัตรผู้ใช้",
    completematerial: "ข้อมูลครบถ้วน",
    choosehost: "เลือกโฮสต์",
    Selectagrouptolistento: "เลือกกลุ่มที่คุณต้องการตรวจสอบ",
    Terminalrenewaldetails: "รายละเอียดการต่ออายุเทอร์มินัล",
    managementplatform: "แพลตฟอร์มการจัดการ",
    electricfence: "รั้วไฟฟ้า",
    Electronicfencerecords: "บันทึกรั้วไฟฟ้า",
    Registeraccount: "ลงทะเบียนบัญชี",
    Boundcompanyusers: "ผู้ใช้บริษัทที่ถูกผูกไว้",
    Unboundcompanyusers: "ผู้ใช้บริษัทที่ไม่ได้ผูกไว้",
    Listofboundcompanyusers: "รายชื่อผู้ใช้บริษัทที่ถูกผูกไว้",
    Listofunboundcompanyusers: "รายชื่อผู้ใช้บริษัทที่ไม่ได้ผูกไว้",
  },

  setup: {
    setup: "ตั้งค่า",
    Change_Password: "เปลี่ยนรหัสผ่าน",
    user_information: "ข้อมูลส่วนตัว",
    Reset_Login_Password: "รีเซ็ตรหัสผ่านเข้าสู่ระบบ",
    Modify_payment_password: "เปลี่ยนรหัสผ่านการชำระเงิน",
    about: "เกี่ยวกับ",
    Problem_feedback: "คำถาม ข้อเสนอแนะ",
    Verify_phone: "ยืนยันเบอร์มือถือ",
    Set_payment_password: "ตั้งรหัสผ่านการชำระเงิน",
  },

  org: {
    org_name: "ชื่อหน่วย",
    createCompany: "หน่วยใหม่",
    UnitAccount: "บัญชีหน่วย",
    createGroups: "สร้างกลุ่มได้ 16 กลุ่มในเวลาเดียวกัน",
    plGroups:
      "เพิ่มจำนวนธรรมชาติลงในส่วนต่อท้ายของชื่อกลุ่มแบตช์และดำเนินการต่อด้วยจำนวนธรรมชาติของชื่อที่ซ้ำกัน",
  },
  consume: "การบริโภค",
  area: "พื้นที่",
  logout: "ออกจากระบบ",
  VerifyPC: "เปิดลิงก์บนพีซี",
  // connect: 'การเชื่อมต่อเซิร์ฟเวอร์ผิดปกติ',
  connect: "กำลังโหลด...",
  existing: "ที่มีอยู่เดิม",
  individual: "บุคคล",
  Quantityis: "ปริมาณเป็น 0 และไม่สามารถเรียกคืนได้",
  Withdrawal_quantity: "ปริมาณที่กู้คืนไม่สามารถมากกว่าปริมาณที่มีอยู่ได้",
  click_load: "คลิกเพื่อโหลดเพิ่มเติม",
  refresh_successfully: "รีเฟรชสำเร็จ",
  search: "ค้นหา",
  detail: "รายละเอียด",
  edit: "แก้ไข",
  delete: "ลบ",
  confirm: "แน่นอน",
  cancel: "ยกเลิก",
  call_back: "หดกลับ",
  time: "เวลา",
  category: "หมวดหมู่",
  title: "ชื่อ",
  data: "วันที่",
  starting_date: "วันที่เริ่มต้น",
  ending_date: "วันที่สิ้นสุด",
  starting_time: "เวลาเริ่มต้น",
  ending_time: "ระยะเวลาสิ้นสุด",
  type: "พิมพ์",
  please_select: "กรุณาเลือก",
  content: "เนื้อหา",
  notice: "แจ้ง",
  tuneto_agent: "โอนไปยังตัวแทน",
  beingTransferred_agent: "ตัวแทนโอน",
  thefence: "รั้ว",
  member: "สมาชิก",
  users: "ผู้ใช้",
  searchuser: "ค้นหาผู้ใช้งาน",
  group: "กลุ่ม",
  searchgroup: "ค้นหากลุ่ม",
  company: "หน่วย",
  searchunit: "ค้นหาหน่วยงาน",
  agent_name: "ตัวแทน",
  prefixnickname: "คำนำหน้าชื่อเล่น",
  user_name: "ชื่อผู้ใช้",
  company_name: "หน่วยงานที่เกี่ยวข้อง",
  user_info: "ข้อมูลผู้ใช้",
  sale: "ขาย",
  create_user: "สร้างผู้ใช้",
  start_service: "เปิดใช้งานบริการ",
  recycle_recycled: "เรียกคืน/เรียกคืน",
  delete_users: "การลบผู้ใช้",
  deletequantity: "ลบปริมาณ",
  purchasement: "ซื้อ",
  change_agents: "ตัวแทนการเปลี่ยนแปลง",
  voice: "เสียง",
  recording: "การบันทึก",
  position: "ตำแหน่ง",
  thefence: "รั้ว",
  video: "วีดีโอ",
  recycle: "หดกลับ",
  recycled: "เรียกคืน",
  card_type: "ประเภทบัตรบริการ",
  card_type1: "ประเภทบัตรบริการ",
  select_card_type: "เลือกประเภทบัตรบริการ",
  card_number: "จำนวนบัตรบริการ",
  ptt_card: "การ์ดเสียง",
  recording_card: "การ์ดบันทึก",
  gps_card: "การ์ดวางตำแหน่ง",
  sos_card: "การ์ด SOS",
  bounding_card: "การ์ดรั้ว",
  video_card: "การ์ดแสดงผลวิดีโอ",
  duplex_card: "การ์ดดูเพล็กซ์",
  vipcard: "บัตรวีไอพี",
  ptt_card_sale: "ขายการ์ดเสียง",
  recording_card_sale: "บันทึกการขายการ์ด",
  gps_card_sale: "ขายบัตรสถานที่",
  sos_card_sale: "ขายการ์ด SOS",
  bounding_card_sale: "ขายบัตรรั้ว",
  video_card_sale: "ขายการ์ดจอ",
  Duplexcardsales: "จำหน่ายการ์ดดูเพล็กซ์",
  vipcardsales: "จำหน่ายบัตรวีไอพี",
  pttgpssales: "การขายผ่าน PTT+GPS",
  usevoicecard: "การใช้การ์ดเสียง",
  userecordingcard: "การใช้การ์ดบันทึก",
  uselocatorcard: "การใช้การ์ดตำแหน่งที่ตั้ง",
  useSOScard: "การใช้การ์ด SOS",
  usefencecard: "ใช้การ์ดรั้ว",
  usevideocard: "การใช้การ์ดวิดีโอ",
  Useaduplexcard: "การใช้การ์ดดูเพล็กซ์",
  usepttgps: "การใช้ PTT+GPS",
  usevipcard: " ใช้บัตรวีไอพี",
  voiceservicecard: "การ์ดบริการเสียง",
  recordingservicecard: "บัตรบริการบันทึก",
  locationservicecard: "บัตรบริการระบุตำแหน่ง",
  SOSservicecard: "บัตรบริการ SOS",
  fenceservicecard: "บัตรบริการรั้ว",
  videoservicecard: "การ์ดบริการวิดีโอ",
  Dualservicecard: "การ์ดบริการสองหน้า",
  vipservicecard: "บัตรบริการวีไอพี",
  voiceservice: "บริการเสียง",
  recordingservice: "บริการบันทึกเสียง",
  locationservice: "บริการระบุตำแหน่ง",
  SOSservice: "บริการ SOS",
  fenceservice: "บริการรั้ว",
  videoservice: "บริการวิดีโอ",
  duplexservice: "บริการดูเพล็กซ์",
  recordingcardrecycling: "การรีไซเคิลการ์ดบันทึก",
  LocationCardRecycling: "การวางตำแหน่งการรีไซเคิลบัตร",
  SOSCardRecycling: "การรีไซเคิลการ์ด SOS",
  FenceCardRecycling: "การรีไซเคิลบัตรรั้ว",
  videocardrecycling: "การรีไซเคิลการ์ดวิดีโอ",
  Duplexcardrecycling: "การกู้คืนการ์ดดูเพล็กซ์",
  VoiceFeatureNotification: "การแจ้งเตือนฟังก์ชั่นเสียง",
  Notificationofrecordingfunction: "การแจ้งเตือนฟังก์ชั่นการบันทึก",
  Positioningfeaturenotification: "ฟังก์ชั่นแจ้งเตือนตำแหน่ง",
  SOSfunctionnotification: "การแจ้งเตือนฟังก์ชั่น SOS",
  Fencefeaturenotification: "การแจ้งเตือนฟังก์ชั่นรั้ว",
  VideoFeatureNotification: "การแจ้งเตือนฟังก์ชั่นวิดีโอ",
  DuplexFeatureNotification: "การแจ้งเตือนฟังก์ชั่นดูเพล็กซ์",
  PTTGPSFeatureNotification: "การแจ้งเตือน PTT+GPS",
  automatically: "ลบการแจ้งเตือนผู้ใช้ทดสอบโดยอัตโนมัติ",
  DeleteExpired: "การแจ้งเตือนการลบผู้ใช้ที่หมดอายุ",
  remained: "สมดุล",
  pieces: "เปิด",
  residue: "ที่เหลืออยู่",
  recycle_successfully: "เรียกคืนความสำเร็จ",
  None_record: "ยังไม่มีบันทึก",
  this_month: "เดือนนี้",
  Year: "ปี",
  moon: "ดวงจันทร์",
  day: "วัน",
  weekly1: "ในวันจันทร์",
  weekly2: "วันอังคาร",
  weekly3: "วันพุธ",
  weekly4: "วันพฤหัสบดี",
  weekly5: "วันศุกร์",
  weekly6: "วันเสาร์",
  weekly7: "วันอาทิตย์",
  submit: "ส่ง",
  modify_successfully: "การแก้ไขสำเร็จแล้ว",
  confirm1: "ยืนยัน",
  lumpsum: "เงินก้อน",
  selltoagents: "ขายให้ตัวแทน",
  nametips:
    "ชื่อเล่นที่คุณป้อนเป็นเพียงคำนำหน้าชื่อเล่นของผู้ใช้ ส่วนคำต่อท้ายเป็นจำนวนธรรมชาติตามจำนวนผู้ใช้ที่คุณสร้าง ตัวอย่างเช่น ชื่อเล่นที่คุณป้อนคือ",
  nametips2: "ชื่อเล่นของผู้ใช้ทั้งสองที่คุณสร้างขึ้นคือ",
  nametips3: "คราวหน้า",
  nametips4: "ชื่อเล่น ชื่อผู้ใช้ พร้อมคำนำหน้าจะขยายออกไป",
  nametips5: "รอ",
  IMEIscancodetoadd: "สแกนรหัส IMEI เพื่อเพิ่ม",
  IMEIinputadded: "เพิ่มการป้อน IMEI แล้ว",
  IMEIinputaddedtocreate: "ใส่ IMEI และเพิ่มผู้ใช้ได้สูงสุด 10 คน",
  Starttherecordingservice: "เริ่มการบันทึกบริการ",
  Turnonlocationservices: "เปิดบริการระบุตำแหน่ง",
  EnableSOSservice: "เปิดใช้งานบริการ SOS",
  Startfenceservice: "เปิดใช้งานบริการรั้ว",
  Turnondualservice: "เปิดใช้งานบริการดูเพล็กซ์",
  Turnonthevideoservice: "เปิดใช้งานบริการวิดีโอ",
  EnablePTTservice:'เปิดใช้งานบริการ PTT',
  EnableVIPservice:'เปิดใช้งานบริการวีไอพี',
  PTTGPSService:"บริการเสียง + ตำแหน่งที่ตั้ง",
  Usercomments: "หมายเหตุผู้ใช้",
  Agentnote: "หมายเหตุตัวแทน",
  total: "ทั้งหมด",
  settlement: "การตั้งถิ่นฐาน",
  hint: "คำใบ้",
  Areyousuretoremove: "ยืนยันการลบ?",
  Areyousuretoclearall: "คุณแน่ใจว่าจะเคลียร์ทั้งหมดใช่ไหม？",
  cocreated: "สร้าง",
  accountssubtotal: "ยอดรวมย่อยของแต่ละบัญชี",
  Scancodeentryarea: "พื้นที่ป้อนรหัสสแกน",
  empty: "ชัดเจน",
  none: "ไม่มี",
  Second: "ที่สอง",
  Salesvolume: "ปริมาณการขาย",
  Purchasequantity: "ปริมาณการสั่งซื้อ",
  returnquantity: "จำนวนคืนสินค้า",
  Recoveredquantity: "ปริมาณที่กู้คืนได้",
  returnquantity2: "จำนวนคืนสินค้า",
  setasdefaultgroup: "ตั้งค่าเป็นกลุ่มเริ่มต้น",
  newgroup: "สร้างกลุ่มใหม่",
  groupname: "ชื่อกลุ่ม",
  selected: "เลือกแล้ว",
  groups: "กลุ่ม",
  allgroups: "กลุ่มทั้งหมด",
  Groupduration: "ระยะเวลาของกลุ่ม",
  calltime: "เวลาพูดคุย",
  groupmembers: "สมาชิกในกลุ่ม",
  Modifygroupname: "แก้ไขชื่อกลุ่ม",
  priority: "ลำดับความสำคัญ",
  remove: "ลบ",
  addmembers: "เพิ่มสมาชิก",
  levelone: "ระดับ 1",
  Secondary: "ระดับ 2",
  Levelthree: "ระดับ 3",
  Levelfour: "ระดับ 4",
  Fifthgrade: "ระดับ 5",
  OKtoadd: "ยืนยันการเพิ่ม",
  reenter: "เข้าใหม่อีกครั้ง",
  Setdigitservicecardpassword: "ตั้งรหัสผ่านบัตรบริการ 6 หลัก",
  Enteragaintoconfirm: "กรุณาเข้าสู่ระบบอีกครั้งเพื่อยืนยัน",
  Enterthedigitservicecardpassword: "กรอกรหัสบัตรบริการ 6 หลัก",
  consumptioncard: "การ์ดกำหนดตำแหน่งการบริโภค",
  ConsumeSOScard: "การใช้การ์ด SOS",
  Consumefencecard: "บริโภคการ์ดรั้ว",
  Consumptionrecordingcard: "การใช้การ์ดบันทึก",
  Consumeduplexcard: "บริโภคการ์ดดูเพล็กซ์",
  Consumptionvideocard: "กินการ์ดจอ",
  account: "บัญชี",
  unfilled: "ไม่ได้กรอก",
  contactnumber: "เบอร์ติดต่อ",
  emailaddress: "ที่อยู่อีเมล์",
  mailingaddress: "ที่อยู่สำหรับติดต่อ",
  Belonginggroup: "กลุ่ม",
  Nickname: "ชื่อเล่น",
  suspendaccount: "บัญชี",
  unitdispatcher: "ผู้ควบคุมหน่วย",
  dispatcher: "ผู้จัดส่ง",
  basestationpositioning: "การวางตำแหน่งสถานีฐาน",
  GPSlocation: "การระบุตำแหน่ง GPS",
  positioninginterval: "ช่วงกำหนดตำแหน่ง",
  videocall: "วีดีโอคอล",
  strongpullvideo: "วิดีโอแรงดึงสูง",
  videoreturn: "อัพโหลดวิดีโอ",
  Numberchangeperiod: "กำหนดเวลาการเปลี่ยนแปลงหมายเลข",
  UsersNickname: "ชื่อเล่นของผู้ใช้",
  volumeactivation: "การเปิดใช้งานเป็นกลุ่ม",
  batchselection: "การเลือกชุด",
  searchhistory: "ประวัติการค้นหา",
  returnnotice: "กลับไปยังการแจ้งเตือน",
  Notificationofbeingwithdrawn: "การแจ้งการเพิกถอน",
  takebacknotice: "ประกาศการเพิกถอน",
  bouncenotification: "แจ้งการคืนสินค้า",
  Notificationofbeingreturned: "แจ้งกลับ",
  Createusernotification: "สร้างการแจ้งเตือนผู้ใช้",
  purchasenotice: "การแจ้งเตือนการซื้อ",
  salereminder: "การแจ้งเตือนการขาย",
  today: "วันนี้",
  yesterday: "เมื่อวาน",
  thedaybeforeyesterday: "เมื่อวานนี้",
  OriginalIMEI: "IMEI ดั้งเดิม",
  NewIMEI: "IMEI ใหม่",
  replace: "แทนที่",
  verificationcode: "รหัสตรวจสอบ",
  resendverificationcode: "ส่งรหัสยืนยันอีกครั้ง",
  back: "กลับ",
  host: "เจ้าภาพ",
  listeninggroup: "กลุ่มติดตามตรวจสอบ",
  Addlisteninggroup: "เพิ่มกลุ่มการตรวจสอบ",
  Nodata: "ยังไม่มีข้อมูล",
  Corenewal: "รวมต่ออายุ",
  Accountssubtotal: "ยอดรวมย่อยของแต่ละบัญชี",
  Confirmrenewal: "ยืนยันการต่ออายุ",
  add_groupname_tips:
    "เพิ่มจำนวนธรรมชาติลงในส่วนต่อท้ายของชื่อกลุ่มแบตช์และดำเนินการต่อด้วยจำนวนธรรมชาติของชื่อที่ซ้ำกัน",
  Dataloadingcomplete: "การโหลดข้อมูลเสร็จสมบูรณ์",
  Usercreatedgroups: "กลุ่มที่สร้างโดยผู้ใช้",
  Lord: "เจ้าของกลุ่ม",
  chooseagroupleader: "เลือกเจ้าของกลุ่ม",
  alluser: "ผู้ใช้ทั้งหมด",
  SOSalarmsintemporarygroupsarenotrecorded:
    "สัญญาณเตือน SOS ในกลุ่มชั่วคราวจะไม่ถูกบันทึกไว้",
  username: "ชื่อผู้ใช้",
  startingtime: "เวลาเริ่มต้น",
  Processor: "ผู้จัดการ",
  processtime: "ระยะเวลาในการประมวลผล",
  Unprocessed: "ไม่ผ่านการประมวลผล",
  Processed: "ดำเนินการแล้ว",
  deleted: "ลบแล้ว",
  name: "ชื่อ",
  address: "ที่อยู่",
  Warmreminder:
    "เคล็ดลับ: ข้อมูลจากบุคคลที่สามอาจมีข้อผิดพลาดและมีไว้สำหรับการอ้างอิงเท่านั้น",
  SOSlocation: "ที่ตั้ง SOS",
  permanent: "ถาวร",
  Latitudeandlongitude: "ละติจูดและลองจิจูด",
  Reportingtime: "การรายงานเวลา",
  Positioningtime: "การวางตำแหน่งเวลา",
  op1: "เปิด",
  op2: "การปิด",
  groupban: "การปิดเสียงแบบกลุ่ม",
  setptt: "ตั้งค่าช่วงเวลาการให้บริการเสียง",
  Determinethemodification: "ยืนยันการเปลี่ยนแปลง",
  Onemonth: "หนึ่งเดือน",
  Threemonths: "สามเดือน",
  Halfayear: "ครึ่งปี",
  Expiredate: "เวลาหมดอายุ",
  year1: "หนึ่งปี",
  year2: "ปีที่ 2",
  year3: "สามปี",
  Sun: "วัน",
  Mon: "หนึ่ง",
  Tue: "สอง",
  Wed: "สาม",
  Thu: "สี่",
  Fri: "ห้า",
  Sat: "หก",
  Membermanagement: "การจัดการสมาชิก",
  Validpermanently: "ถาวร",
  Enteralarm: "เข้าสู่การเตือนภัย",
  Leavealarm: "ออกจากนาฬิกาปลุก",
  repeat: "ทำซ้ำ",
  Updatefence: "อัพเดทรั้ว",
  Triggermode: "วิธีการทริกเกอร์",
  Validperiod: "ระยะเวลาใช้งาน",
  start: "เริ่ม",
  end: "เสร็จ",
  Validdate: "วันที่เริ่มใช้บังคับ",
  fencekeeper: "ผู้จัดการรั้ว",
  Membermanagement: "การจัดการสมาชิก",
  fencename: "ชื่อรั้ว",
  Editfence: "แก้ไขรั้ว",
  Setupafencemanager: "ตั้งค่าตัวจัดการรั้ว",
  Fencedetails: "รายละเอียดรั้ว",
  Currentoutofboundsrecord: "บันทึกการออกนอกเขตปัจจุบัน",
  Historicalcrossborderrecords: "บันทึกการข้ามแดนทางประวัติศาสตร์",
  Allfences: "รั้วทั้งหมด",
  Triggertime: "เวลาทริกเกอร์",
  Releasetime: "เวลาปล่อยตัว",
  NoExit: "ห้าม",
  NoEntry: "ห้ามเข้า",
  Recordinglist: "รายการบันทึก",
  temporarygroup: "กลุ่มชั่วคราว",
  Voicelicensetype: "ประเภทการ์ดเสียง",
  Voicelicensetime: "เวลาการ์ดเสียง",
  UTCtimeTips: "เวลาหมดอายุคือเวลา UTC",
  Determinethereplacement: "ยืนยันการเปลี่ยน",
  Regionalreplacement: "การเปลี่ยนแปลงภูมิภาค",
  Recoverypassword: "กู้คืนรหัสผ่าน",
  usertype: "ประเภทผู้ใช้",
  Singlefunctioncarduser: "ผู้ใช้บัตรฟังก์ชันเดียว",
  vipcarduser: "ผู้ใช้บัตร VIP",
  PTTGPS: "PTT+GPS",
  PTTGPSuser: "ผู้ใช้ PTT+GPS",
  display: "การแสดงข้อมูลสมาชิก",
  Service_card_display: "การแสดงบัตรบริการ",
  RequiredvoiceserviceorVIPservice: "บริการเสียงที่จำเป็นหรือบริการ VIP",
  is_card: {
    ptt: "เสียง",
    recording: "การบันทึก",
    gps: "ตำแหน่ง",
    sos: "สัญญาณขอความช่วยเหลือ",
    bounding: "รั้ว",
    duplex: "ดูเพล็กซ์",
    vip: "วีไอพี",
  },
  Dispatcherrole: "บทบาทผู้จัดส่ง",
  ServiceTimeDisplay:'แสดงข้อมูลบริการ',
  show: "แสดง",
  point: "ฟังก์ชั่นการโทรครั้งเดียว",
  IMEIchange: "การแก้ไข IMEI",
  Register: "ลงทะเบียน",
  Bindingdevice: "อุปกรณ์ที่ถูกผูกไว้",
  Notactivated: "ไม่ได้เปิดใช้งาน",
  Platformcreation: "การสร้างแพลตฟอร์ม",
  Userregistration: "การลงทะเบียนผู้ใช้",
  Binding: "การยกเลิกการเชื่อมโยง",
  Notenabled: "ไม่ได้เปิดใช้งาน",
  Unbinding: "การยกเลิกการเชื่อมโยง",
  userPatrol:{
    PatrolCard: "บัตรลาดตระเวน",
    Patrol: "ลาดตระเวน",
    DisplayPatrolCard: "แสดงบัตรลาดตระเวน",
    GuardCardRecycling: "การรีไซเคิลบัตรยาม",
    patrolService:"บริการลาดตระเวน",
    ConsumePatrolCards: "บริโภคบัตรลาดตระเวน",
    StartPatrolService: "เริ่มให้บริการลาดตระเวน",
    YourPatrolCardIsInsufficientPleaseRecharge: "บัตรสายตรวจของคุณไม่เพียงพอ กรุณาเติมเงิน!",
    UsingPatrolCards: "การใช้บัตรลาดตระเวน",
    PatrolCardBalanceInsufficient: "ยอดเงินคงเหลือในบัตรตรวจการณ์ไม่เพียงพอ",
    PatrolServiceCard: "บัตรบริการสายตรวจ",
    PatrolCardSales: "จำหน่ายบัตรสายตรวจ",
    PatrolFunctionNotification: "การแจ้งเตือนฟังก์ชั่นการลาดตระเวน",
    PatrolManagement: "การจัดการลาดตระเวน",
    PatrolPlan: "แผนการลาดตระเวน",
    ExecuteTheTask: "ดำเนินการงาน",
    PatrolReport: "รายงานการลาดตระเวน",
    SearchPlan: "แผนการค้นหา",
    Suspended: "ถูกระงับ",
    Enabled: "เปิดใช้งานแล้ว",
    NewPlans: "แผนใหม่",
    TerminalReminderSettings: "การตั้งค่าเตือนความจำเทอร์มินัล",
    ReminderRules: "กฎการเตือนความจำ",
    ReminderTime: "เวลาเตือนความจำ",
    NumberOfReminders: "จำนวนการเตือนความจำ",
    minute: "นาที",
    note1:"บันทึก-หากตั้งเวลาเตือนการเริ่มต้นการลาดตระเวนเป็น30นาทีเตือนผู้ใช้2ครั้งหน้าครับ เหล่าผู้ใช้ที่ร่วมลาดตระเวนก็จะ...30ได้รับนาทีแรก1จะมีการส่งข้อความเตือนก่อนเริ่มต้น15ได้รับนาทีแรก2จะนับจำนวนข้อความแจ้งเตือนเป็นต้น",
    PleaseEnterTheReminderTime: "กรุณาระบุเวลาเตือนความจำ",
    PleaseEnterTheNumberOfReminders:"กรุณาระบุจำนวนการแจ้งเตือน",
    PleaseEnterANumberGreaterThanOrEqualTo20: "กรุณากรอกตัวเลขที่มากกว่าหรือเท่ากับ 20",
    PleaseEnterANumberLessThanOrEqualTo5: "กรุณากรอกตัวเลขที่น้อยกว่าหรือเท่ากับ 5",
    OperationSuccessful: "การดำเนินการสำเร็จ",
    NewPatrolPlan: "แผนการลาดตระเวนใหม่",
    PleaseEnterThePlanName: "กรุณาระบุชื่อแผน",
    UsersWhoNeedPatrols: "ผู้ใช้ที่ต้องการการลาดตระเวน",
    OnlyRegularUsersWhoHaveActivatedThePatrolServiceCanPerformPatrols: "เฉพาะผู้ใช้ทั่วไปที่เปิดใช้งานบริการลาดตระเวนเท่านั้นจึงจะสามารถดำเนินการลาดตระเวนได้",
    EffectiveDateOfThePlan: "วันที่เริ่มใช้แผน",
    PlannedStatus: "สถานะที่วางแผนไว้",
    Week: "สัปดาห์",
    DailyPatrolTime: "เวลาลาดตระเวนประจำวัน",
    TaskGenerationTime: "เวลาในการสร้างงาน",
    AutomaticallyGenerateTheTimeForTheNextDaysScheduledTasksEveryDay:"สร้างเวลาสำหรับงานตามกำหนดการในวันถัดไปโดยอัตโนมัติทุกวัน",
    patrolPoint:"จุดลาดตระเวน",
    save:"บันทึก",
    TheProjectNameAlreadyExists:"ชื่อโครงการมีอยู่แล้ว",
    TheNameConsistsOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols:"ชื่อประกอบด้วยอักขระ 1 ถึง 50 ตัว รวมถึงอักขระจีน ตัวเลข ตัวอักษร และสัญลักษณ์พิเศษ",
    PleaseSelectTheUserWhoNeedsToBePatrolled:"กรุณาเลือกผู้ใช้ที่ต้องการให้ตรวจสอบ",
    PleaseSelectTheEffectiveDateOfThePlan:"กรุณาเลือกวันที่เริ่มใช้แผน",
    PleaseSelectDailyPatrolTime: "กรุณาเลือกเวลาลาดตระเวนรายวัน",
    TheEndTimeMustBeGreaterThanTheStartTime: "เวลาสิ้นสุดจะต้องมากกว่าเวลาเริ่มต้น",
    PleaseSelectTheTaskGenerationTimeForTheNextDay: "กรุณาเลือกเวลาสร้างงานสำหรับวันถัดไป",
    PleaseAddPatrolPoints: "กรุณาเพิ่มจุดตรวจลาดตระเวน",
    PatrolUsers:"ผู้ใช้บริการสายตรวจ",
    AddUser: "เพิ่มผู้ใช้",
    ConfirmAdd: "ยืนยันการเพิ่ม",
    PleaseSelectTheUserYouWishToAdd: "กรุณาเลือกผู้ใช้ที่คุณต้องการเพิ่ม",
    UserAddedSuccessfully:"เพิ่มผู้ใช้สำเร็จแล้ว",
    AddTo: "เพิ่มไปยัง",
    PatrolPointNames:"ชื่อจุดลาดตระเวน",
    PleaseEnterThePatrolPointName:"กรุณากรอกชื่อจุดตรวจ",
    RequiredTheNameMustConsistOf1To50CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "(ข้อกำหนด: ชื่อต้องประกอบด้วยอักขระ 1 ถึง 50 ตัว รวมถึงอักขระจีน ตัวเลข ตัวอักษร และสัญลักษณ์พิเศษ)",
    NFCNumber: "หมายเลข NFC",
    PleaseEnterYourNFCNumber: "กรุณากรอกหมายเลข NFC ของคุณ",
    Required150Characters:"(จำเป็นต้องมี: 1-50 ตัวอักษร)",
    ThePatrolPointNameAlreadyExists: "ชื่อจุดตรวจมีอยู่แล้ว",
    TheNameConsistsOf150CharactersIncludingChineseCharactersNumbersLettersAndSpecialSymbols: "ชื่อประกอบด้วยอักขระ 1-50 ตัว รวมถึงอักขระจีน ตัวเลข ตัวอักษร และสัญลักษณ์พิเศษ",
    Remark: "หมายเหตุ",
    NoteWithin100Characters: "หมายเหตุ: ภายใน 100 ตัวอักษร",
    CreationSuccessful: "การสร้างสำเร็จแล้ว",
    EditorsPatrolPoint: "จุดตรวจของบรรณาธิการ",
    save1: "บันทึก",
    ModificationSuccessful: "การแก้ไขสำเร็จแล้ว",
    delete: "ลบ",
    Remove: "ลบ",
    AreYouUreYouWantToDeleteThisPatrolPoint: "คุณแน่ใจว่าต้องการลบจุดตรวจนี้หรือไม่?",
    DeletionSuccessful: "การลบสำเร็จแล้ว",
    EditorsPatrolPlan: "แผนการลาดตระเวนของบรรณาธิการ",
    PatrolPlanDetails: "รายละเอียดแผนการลาดตระเวน",
    AreYouSureYouWantToSuspendThePlanIfSuspendedTodaysScheduledPatrolsWillBeCancelled: "คุณแน่ใจไหมว่าต้องการระงับแผน? หากถูกระงับ กำหนดการลาดตระเวนในวันนี้จะถูกยกเลิก",
    OperationSuccessful1: "การดำเนินการสำเร็จ",
    PleaseSelectTime: "กรุณาเลือกเวลา",
    FullPlan: "แผนเต็ม",
    AllUsers:"ผู้ใช้ทั้งหมด",
    ProjectName:"ชื่อโครงการ",
    PatrolUsers1: "ผู้ใช้บริการสายตรวจ",
    PatrolTime: "เวลาลาดตระเวน",
    NotStarted: "ยังไม่ได้เริ่มต้น",
    inProgress: "กำลังดำเนินการอยู่",
    Completed: "สมบูรณ์",
    MissedInspection: "การตรวจสอบที่พลาด",
    PleaseEnterYourUsername: "กรุณากรอกชื่อผู้ใช้ของคุณ",
    ExecutionDetails: "รายละเอียดการดำเนินการ",
    PatrolPointNames1: "ชื่อจุดลาดตระเวน",
    PatrolYype: "ประเภทการลาดตระเวน",
    ExecutionResult: "ผลการดำเนินการ",
    position: "ตำแหน่ง",
    NFC: "เอ็นเอฟซี",
    Bluetooth: "บลูทูธ",
    PleaseSelectPatrolUser: "กรุณาเลือกผู้ใช้สายตรวจ",
    DailyStatistics: "สถิติรายวัน",
    WeeklyStatistics: "สถิติรายสัปดาห์",
    MonthlyStatistics: "สถิติรายเดือน",
    time: "เวลา",
    NumberOfPlannedExecutions: "จำนวนการดำเนินการที่วางแผนไว้",
    ActualNumberOfExecutions: "จำนวนการดำเนินการจริง",
    NumberOfMissedInspections: "จำนวนการตรวจสอบที่พลาด",
    CompletionRate: "อัตราการสำเร็จ",
    PleaseEnterYourUsername : "กรุณากรอกชื่อผู้ใช้ของคุณ",
    Existing: "ที่มีอยู่เดิม",
    NewPatrolPoints:"จุดตรวจใหม่"
  },
  minute:'นาที',
  Reclaim:'เรียกคืน',
  TestUser:'ผู้ใช้ทดสอบ',
  test_t:'การทดสอบ',
  Formal:'เป็นทางการ',
  Testuserscannotactivatefeatureservices:'ผู้ใช้ทดสอบไม่สามารถเปิดใช้งานบริการฟีเจอร์ได้!'
};
